
/**
 * 若路由是只需要登录,不需要角色权限限制的路由(例如：与其他第三方系统页面集成的路由），请在此配置路由列表
 * @returns {any[]}
 */
export function getWhiteList(){
    let rightMenu = new Array();
    // 以下注释部分为示例代码，
    rightMenu.push("/roleTag");
    rightMenu.push("/nutritionManage/tableView");
    rightMenu.push("/nutritionManage/tableRecipe");
    return rightMenu;
}

/**
 * 若路由是公开不需要登录访问的页面，请在此配置页面路由列表
 * @returns {any[]}
 */
export function getPublicList(){
    let rightMenu = new Array();
    // 以下注释部分为示例代码，
    // rightMenu.push("/cmn/worker/historyLink");
    // rightMenu.push("/cmn/worker/costmgt");
    return rightMenu;
}
